<template>
	<Accessible
		name="nicknamemodal"
		trapped
		autoFocus
		:wait="100"
		:tabOrder="[
			{ css: '.pronto-input' },
			{ css: '.pronto-btn.primary', clickOnEnter: true },
			{ css: '.pronto-btn.default', clickOnEnter: true },
			{ css: '.modal-close', clickOnEnter: true },
		]"
	>
		<StandardModal
			small
			open
			:title="$t('chat_drawer_action_nickname')"
			:confirmText="$t('chat_messageaction_save')"
			@confirm="updateNickname"
			@cancel="close"
			:confirmProps="{ loading: isLoading }"
			ref="modal"
		>
			<div class="nickname-wrapper">
				<i18n-t
					keypath="groupsettings_nickname_modal_title"
					tag="div"
					class="title"
				>
					<template #GroupName>
						<span v-text="target.title" />
					</template>
				</i18n-t>

				<FormItem
					:label="$t('chat_drawer_action_nickname')"
					:help="$t('groupsettings_nickname_modal_subtitle')"
				>
					<Input
						class="nickname-input"
						:placeholder="$t('groupsettings_nickname_change_alert_placeholder')"
						v-model="nickname"
						autoFocus
						@enter="updateNickname()"
					/>
				</FormItem>
			</div>
		</StandardModal>
	</Accessible>
</template>

<script>
import {
	getCategory,
	getMyMembershipForBubble,
	setCategory,
	setMembership,
	getChat,
} from '@/store'
import { StandardModal, Input, FormItem } from '@/components/common'
import { post } from '../../helpers/api'
import Accessible from '@/components/common/Accessible'

export default {
	components: { StandardModal, Input, Accessible, FormItem },
	props: ['categoryId', 'chatId'],
	data() {
		return {
			nickname: '',
			isLoading: false,
		}
	},

	emits: ['close'],

	mounted() {
		if (this.chatId) {
			this.nickname = getMyMembershipForBubble(this.chatId).alias || ''
		} else {
			const { usercategory } = getCategory(this.categoryId)
			this.nickname = usercategory?.alias ?? ''
		}
	},

	computed: {
		target() {
			if (this.categoryId) {
				return getCategory(this.categoryId)
			} else {
				return getChat(this.chatId)
			}
		},
	},

	methods: {
		close() {
			this.$emit('close')
		},

		async updateNickname() {
			this.isLoading = true
			const body = { alias: this.nickname }

			if (this.chatId) {
				body.bubble_id = this.chatId
			} else {
				body.category_id = this.categoryId
			}

			const url = this.chatId
				? '/api/v1/membership.update'
				: '/api/v1/category.update'

			try {
				const { data } = await post(url, body)
				if (this.chatId) {
					setMembership(data.membership)
				} else {
					setCategory(data.category)
				}
				this.close()
			} catch (e) {
				console.error(e)
				this.$refs.modal.$alert.error(e)
			}
			this.isLoading = false
		},
	},
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.nickname-wrapper {
	@include flex-column-center;
	padding: 16px 40px;
	.title {
		text-align: center;
		margin-bottom: 16px;
		span {
			font-family: Avenir-Heavy;
		}
	}
}

.help-text {
	font-family: Avenir-Roman;
	font-size: 16px;
	color: #4f5053;
	text-align: center;
	margin-top: 16px;
}
</style>
